import { render, staticRenderFns } from "./LoanInformationReview.vue?vue&type=template&id=1bf3d24f&"
import script from "./LoanInformationReview.vue?vue&type=script&lang=js&"
export * from "./LoanInformationReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports